import React, { useState, useEffect } from "react";
import { Tab, Tabs } from "@material-ui/core";
import { FormattedMessage } from "react-intl";
import FixedPageItem from "../custom/FixedPageItem";
import HeaderPageItem from "../custom/HeaderPageItem";
import PageContainer from "../custom/Page";
import Search from "./components/Management/Search";
import ReportsMenu from "./components/ReportsMenu";
import SummaryManagement from "./components/Management/SummaryManagement";
import UserHierarchy from "./components/UserHierarchy";
import { useSelector } from "react-redux";

const validTabs = ["summary", "team", "search", "reports"];

const TeamManagement = ({ match, history }) => {
  const currentUser = useSelector((state) => state.user.user.me);
  const tabParam = match?.params?.tab;
  const initialTab = tabParam && validTabs.includes(tabParam) ? tabParam : "summary";
  const [tabName, setTabName] = useState(() => initialTab);

  const indexContent = {
    summary: <SummaryManagement />,
    team: (
      <UserHierarchy
        enableInfoValues={false}
        userId={currentUser.id}
        isRoot
        enableHeader={false}
      />
    ),
    search: <Search />,
    reports: (
      <ReportsMenu
      enableContractsByAgent
      enableContractsByHierarchy
      enableUsersReportSection
      enableManagerReportSection
      enableContractsAllBelow
      />
    ),
  };

  useEffect(() => {
    if (tabParam && tabParam !== tabName && validTabs.includes(tabParam)) {
      setTabName(tabParam);
    }
  }, [tabParam, tabName]);

  const handleTabChange = (event, newTabName) => {
    if (validTabs.includes(newTabName)) {
      setTabName(newTabName);
      history.push(`/team-management/${newTabName}`);
    }
  };

  return (
    <PageContainer>
      <HeaderPageItem title="app.team.management" />
      <FixedPageItem
        position="top"
        height={50}
      >
        <Tabs
          variant="fullWidth"
          indicatorColor="primary"
          textColor="primary"
          value={tabName}
          onChange={handleTabChange}
        >
          <Tab
            value="summary"
            label={<FormattedMessage id="app.resume" />}
          />
          <Tab
            value="team"
            label={<FormattedMessage id="app.team" />}
          />
          <Tab
            value="search"
            label={<FormattedMessage id="app.search" />}
          />
          <Tab
            value="reports"
            label={<FormattedMessage id="app.reports" />}
          />
        </Tabs>
      </FixedPageItem>
      {indexContent[tabName]}
    </PageContainer>
  );
};

export default React.memo(TeamManagement);
